<template>
  <div class="hotel-info">
    <div class="col-12 px-0">
      <ul>
        <li v-for="(message, index) in messages" :key="index" class="mb-1 text text-12 ml-1 d-flex">
          <div class="col-xs">
            <i class="rhg-font-icon--info xs text-12 mr-1"></i>
          </div>
          <div class="col-12 pl-2">
            <strong v-html="message.text"></strong>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoHotelComponent',
  props: {
    messages: {
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.hotel-info {
  display: flex;

  &__message {
    font-size: 12px;
    font-weight: bold;
  }
}
</style>
